const CACHE_KEY = 'media_service_cache';

const getCache = () => {
    try {
        const stored = localStorage.getItem(CACHE_KEY);
        return stored ? JSON.parse(stored) : {};
    } catch (e) {
        console.error("Failed to parse media cache", e);
        return {};
    }
};

const updateCache = (key, value) => {
    try {
        const cache = getCache();
        cache[key] = value;
        localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    } catch (e) {
        console.error("Failed to update media cache", e);
    }
};

const mediaService = {
    fetchSuggestedImage: async (playlist) => {
        let query = []
        if (!playlist || !playlist.tags || playlist.tags.length === 0 || playlist.cover) {
            query = ['music', 'playlist', 'instruments']
        } else {
            query = playlist.tags.map(tag => tag.name)
        }

        try {
            const endpoint = `/api/media/search?q=${encodeURIComponent(query.join(' '))}&per_page=1&page=1`;
            const cache = getCache();

            if (cache[endpoint]) {
                return cache[endpoint];
            }
            const response = await fetch(endpoint);
            if (!response.ok) throw new Error('Search failed');

            const data = await response.json();
            if (data.photos && data.photos.length > 0) {
                // Prefer large2x, fallbacks
                const img = data.photos[0];
                const src = img.src.large2x || img.src.large || img.src.medium;
                updateCache(endpoint, src);
                return src;
            } else {
                return null;
            }
        } catch (error) {
            console.error("Failed to fetch suggested image", error);
            return null;
        }
    },
}

export default mediaService;